// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JoinCallBanner_wrapper__ATlNe","buttonWrapper":"JoinCallBanner_buttonWrapper__yYkv1","text":"JoinCallBanner_text__uHwyt"};